export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_RR_310_ACELERADOR_01.6d885dda.jpg";